import React from 'react';
import type { AuditLogFilters } from '../../../models/auditLog';
import { AUDIT_ACTION_TYPES } from '../../../models/auditLog';

export interface AuditCompanyOption {
  companyId: string;
  companyName: string;
}

export interface AuditFiltersPanelProps {
  filters: AuditLogFilters;
  companies: AuditCompanyOption[];
  onChange: (next: AuditLogFilters) => void;
}

export function AuditFiltersPanel({ filters, companies, onChange }: AuditFiltersPanelProps): React.ReactElement {
  return (
    <div className="bo-admin-toolbar bo-card">
      <label className="bo-field" htmlFor="audit-action-type">
        <span className="bo-field-label">Action type</span>
        <select
          id="audit-action-type"
          className="bo-input"
          value={filters.actionType ?? ''}
          onChange={(event) => onChange({ ...filters, actionType: event.target.value || undefined })}
        >
          <option value="">All</option>
          {AUDIT_ACTION_TYPES.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </label>
      <label className="bo-field" htmlFor="audit-company">
        <span className="bo-field-label">Company</span>
        <select
          id="audit-company"
          className="bo-input"
          value={filters.companyId ?? ''}
          onChange={(event) => onChange({ ...filters, companyId: event.target.value || undefined })}
        >
          <option value="">All</option>
          {companies.map((company) => (
            <option key={company.companyId} value={company.companyId}>
              {company.companyName}
            </option>
          ))}
        </select>
      </label>
      <label className="bo-field" htmlFor="audit-from-date">
        <span className="bo-field-label">From</span>
        <input
          id="audit-from-date"
          type="date"
          className="bo-input"
          value={filters.fromDate ?? ''}
          onChange={(event) => onChange({ ...filters, fromDate: event.target.value || undefined })}
        />
      </label>
      <label className="bo-field" htmlFor="audit-to-date">
        <span className="bo-field-label">To</span>
        <input
          id="audit-to-date"
          type="date"
          className="bo-input"
          value={filters.toDate ?? ''}
          onChange={(event) => onChange({ ...filters, toDate: event.target.value || undefined })}
        />
      </label>
    </div>
  );
}
